import { Permission } from "./permission";

export class Role {
    constructor(
        public id = 0,
        public name = '',
        public permissions: Permission[] = []
    ) {
    }
}